<template>
  <b-card no-body style="border: none; height: 100%; margin: 0;">
    <b-table no-provider-paging responsive id="my-table" :items="tableData"
             tbody-tr-class="test"
             :fields="fields" v-on:row-clicked="rowClicked"
             :sort-by="sortBy"
             :sort-desc="sortDesc"
             sort-icon-left
             class="custom-auto-height">
      <template #table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: calcSize(field.key) }"
        />
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  name: 'DefinitionTable',
  components: {},
  props:{
    tableData: {
      type: Array,
      default: () => []
    },
    rowClickCallback: {
      type: Function,
      default: undefined
    },
  },
  mounted() {

  },
  data: () => {
    return {
      sortBy: 'api_name',
      sortDesc: false,
      fields: [
        {key: 'api_name', label: "Name", sortable: true},
        {key: 'format', label: "Ausgabeformat", sortable: true, formatter: "formatFormat"},
        {key: 'create_date', label: "Anlage", formatter: "dateToString", sortable: true},
      ],
      currentPage: 1,
      perPage: 20,
      currentClicked: null,
      indeterminate: false,
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.$emit('page-changed', newValue);
    },
  },
  computed: {
    rows() {
      return this.tableData.length
    },
  },
  methods: {
    calcSize(field) {
      if (field === 'selected') {
        return '36px';
      } else {
        return 'initial';
      }
    },
    rowClicked(item, index, target) {
      this.$router.push("/auswertung/invoice_api_definitions/"+item.id);
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    formatFormat(value) {
      switch (value) {
        case "fixed_length":
          return "feste Feldlänge"
        case "delimiter":
          return "Trennzeichen"
        case "csv":
          return "CSV Format"
        case "template":
          return "mit Templatedatei"
      }
      return value;
    },
    responseError(response) {
      console.log(response)
    },

    changePage(page) {
      if (page !== this.currentPage && ((page - 1) * this.perPage) < this.rows) {
        this.currentPage = page;
      }
    }
  }
}
</script>

<style scoped>


.h-1px {
  height: 1px;
}

.icon-def-grey {
  color: #5f6368;
}

.icon-def-green {
  color: green;
}

::v-deep .table td {
  padding: 0.15rem 0.75rem !important;
}

::v-deep table.b-table > tbody > tr.b-table-details > td {
  border-top: none !important;
  padding: 0px !important;
}

::v-deep .table.b-table>thead>tr>th[aria-sort]:before {
  float: none !important;
  margin-left: 0 !important;
  margin-right: 0.5em !important;
  font-size: larger;
}

::v-deep .table.b-table>thead>tr>th[aria-sort="ascending"] {
  border: 2px solid #c8ced3;;
}

::v-deep .table.b-table>thead>tr>th[aria-sort="descending"] {
  border: 2px solid #c8ced3;;
}

::v-deep .table thead th {
  white-space: nowrap;
}

.message-subject {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  line-height: 30px;
  font-weight: normal;
  color: #202124;
  vertical-align: sub;
}

.message-body {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #383838;
  font-weight: normal;
  vertical-align: sub;
}

.message-memo {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #5f6368;
  font-weight: normal;
  vertical-align: sub;
}
</style>

